'use client';

import { markdownTrilogy } from '@bytel/markdown-trilogy';
import {
    Button,
    ButtonList,
    ButtonVariant,
    Image,
    Modal,
    ModalBody,
    ModalFooter,
    Spacer,
    SpacerSize,
} from '@bytel/trilogy-react';

import { FaiProduct } from '@app-types/fai';

import { Cms } from '@components/cms';

const FaiDetailsModal = ({
    onClose,
    active,
    faiOffer,
}: {
    onClose: () => void;
    active: boolean;
    faiOffer?: FaiProduct;
}) => {
    return (
        <Modal
            active={active}
            onClose={onClose}
            title={faiOffer?.modal_title ?? faiOffer?.title ?? 'Détails de l’offre'}
        >
            <ModalBody>
                {faiOffer?.modal_image?.public_url && (
                    <Image src={faiOffer.modal_image.public_url} alt={faiOffer.modal_title} />
                )}
                <Spacer size={SpacerSize.FIVE} />
                {faiOffer?.modal_content && <Cms content={markdownTrilogy(faiOffer.modal_content)} />}
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.PRIMARY} onClick={onClose}>
                        Fermer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
};

export default FaiDetailsModal;
